/**
 * Axios 설정 파일
 * 전역 axios 인터셉터 및 설정 관리
 */
import axios from 'axios';

import { API_CONFIG } from '../api/config/env';

/**
 * MinddPlugin 초기화
 * 플러그인이 있는 경우 axios 인터셉터를 연결
 *
 * Note: MinddPlugin 타입은 react-app-env.d.ts에 정의되어 있습니다.
 */
export const initializeMinddPlugin = () => {
  if (window.MinddPlugin) {
    window.MinddPlugin.on('MINDD SURVEY', API_CONFIG.ENV, axios.interceptors.response);
  }
};
